module.exports = __webpack_public_path__ + "img/sys-logo.7a4525be.png";